import './styles/_pdp-section.scss';
import Swiper from 'swiper-latest/bundle';
import {isScriptFullyLoaded, markScriptFullyLoaded, onDocumentReady,} from '../utils/dom';
import {removeQueryParams, setQueryParams} from '../utils/url';

import {onAddToCart as onAddToCartService} from '../services/cart';
import {getProductVariantData, getVariantQuantity, isFinalSale, isUnreturnable, retrieveSku,} from '../utils/product';
import OverflowScroller from '../lib/OverflowScroller';
import {replaceWords} from '../services/filter-value';

const DESKTOP_MEDIA = window.matchMedia('(min-width: 1009px)');

const state = {
  elements: {},
  product: window.product,
  optionGroups: [],
  selectedVariant: null,
  klaviyoAccountID: 'QEgd3D',
  isPDP: window.location.pathname.includes('/products/'),
};

const cacheState = () => {
  state.elements = {
    pdpOptionWrappers: document.querySelectorAll('.pdp__option--wrapper'),
    stickyElement: document.querySelector('[data-sticky-element]'),
    quantity: document.querySelector('#quantity'),
    contentWrapper: document.querySelector('.pdp__options--card'),
    sliders: document.querySelector('.pdp-grid--container'),
    quantitySelector: document.querySelector('.quantity__selector'),
    minusBtn: document.querySelector('.quantity__selector--minus'),
    plusBtn: document.querySelector('.quantity__selector--plus'),
    addToCart: document.querySelector('#add-to-cart'),
    colorOptions: document.querySelectorAll('.pdp__options--item'),
    productPrice: document.querySelector('.pdp__content--price-inner'),
    compareAtprice: document.querySelector('.pdp__content--compare-price'),
    productTitle: document.querySelector('.pdp__content--title'),
    productSoldOutLabel: document.querySelector('.pdp__options--sold-out'),
    pdpQuantityWrapper: document.querySelector('.pdp__quantity--box'),
    notifyButton: document.querySelector('.notify__button'),
    notifyBackdrop: document.querySelector('.notify__backdrop'),
    notifyBtn: document.querySelector('.Product__form-cta--sold_out'),
    notifyForm: document.querySelector('.notify__form'),
    notifyEmailInput: document.querySelector('.notify__form input'),
    notifyBtnCta: document.querySelector('.notify__form button'),
    notifyInvalidEmail: document.querySelector('.invalid-email-message'),
    sliderImage: document.querySelectorAll('.slider-img-item'),
    sliderVideo: document.querySelector('.slider-video-item'),
    sliderGrid: document.querySelector('.pdp-grid--slider'),
    sliderZoom: document.querySelectorAll('.pdp__zoom--slider'),
    optionWrapper: document.querySelectorAll('.pdp__options--wrapper'),
    optionColors: document.querySelectorAll('.pdp__options--color'),
    optionColorWrapper: document.querySelector('.pdp__options--mobile-header'),
    colorsContainer: document.querySelector('.pdp__options--bottom'),
    optionBottomBackdrop: document.querySelector('.pdp__options--backdrop'),
    optionColorIcon: document.querySelector('.pdp__options--color-icon'),
    optionColorClose: document.querySelector('.pdp__options--color-close'),
    swiperButtonNext: document.querySelector('.swiper-button-next'),
    swiperButtonPrev: document.querySelector('.swiper-button-prev'),
    accordionProductDescription: document.querySelector(
      '.accordion-product-description'
    ),
    accordionProductMetafield: document.querySelector(
      '.accordion-product-metafield'
    ),
    accordionProductVariant: document.querySelector(
      '.accordion-product-variant'
    ),
    body: document.querySelector('body'),
    header: document.querySelector('.section-header'),
    pdpGrid: document.querySelector('.pdp-grid'),
    klarnaWrappers: document.querySelectorAll('.klarna-pay--wrapper'),
    pdpOptionsCard: document.querySelectorAll('.pdp__options--card'),
    fitGuide: document.querySelector('.fitGuideModal'),
    fitModal: document.querySelector('.modal-bg'),
    fitCloseButton: document.querySelector('.modal-bg__close-btn'),
    onlineExclusiveLabel: document.querySelector('.pdp__content--label'),
    onlineExclusive: document.querySelector('.pdp__label--span'),
    buttonErrorMessage: document.querySelector('.pdp__error--message'),
    formContainer: document.querySelector('.pdp-info--container'),
  };

  state.optionGroups = Array.from(state.elements.pdpOptionWrappers).map(
    (wrapper) => ({
      wrapper,
      fieldSet: wrapper.querySelector('.pdp__option--fieldset'),
      options: wrapper.querySelectorAll('input'),
      selectedTitle: wrapper.querySelector('.pdp__option--selected'),
      errorMessage: wrapper.querySelector('.pdp__option--left'),
    })
  );
};

const sizesMap = new Map([
  ['4XS', '4X SMALL'],
  ['XXXXS', 'XXXX SMALL'],
  ['3XS', '3X SMALL'],
  ['XXXS', 'XXX SMALL'],
  ['2XS', 'XX SMALL'],
  ['XXS', '2X SMALL'],
  ['XS', 'X SMALL'],
  ['S', 'SMALL'],
  ['M', 'MEDIUM'],
  ['L', 'LARGE'],
  ['XL', 'X LARGE'],
  ['2XL', 'XX LARGE'],
  ['XXL', '2X LARGE'],
  ['3XL', '3X LARGE'],
  ['XXXL', 'XXX LARGE'],
  ['4XL', '4X LARGE'],
  ['XXXXL', 'XXXX LARGE'],
]);

const handleQuantityClick = (e) => {
  const actionType = e.target.closest('button').dataset.type;
  if (!actionType) return;

  const quantityInput = state.elements.quantity;
  const currentValue = +quantityInput.value;
  const maxValue = +quantityInput.max;
  const minValue = +quantityInput.min;

  if (actionType === 'plus' && currentValue < maxValue) {
    quantityInput.value = currentValue + 1;
  }

  if (actionType === 'minus' && currentValue > minValue) {
    quantityInput.value = currentValue - 1;
  }
};

const handleQuantityInput = (e) => {
  const input = e.target;
  const newValue = parseInt(input.value, 10);
  if (newValue > input.max) {
    input.value = input.max;
  } else if (newValue < input.min || isNaN(newValue)) {
    input.value = input.min;
  }
}

const initSwipers = () => {
  state.swiper = new Swiper(state.elements.sliders, {
    preloadImages: false,
    loop: true,
    slidesPerView: 1,
    lazy: true,
    speed: 500,
    initialSlide: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
  });
};

const getSelectedColor = () => {
  if (state.product.options[0] === 'Color') {
    return state.product.variants[0]?.option1;
  }
};

const reverseSizesMap = new Map();
sizesMap.forEach((value, key) => {
  if (!reverseSizesMap.has(value)) {
    reverseSizesMap.set(value, key);
  }
});

const formatPrice = (number) => {
  if (isNaN(number)) return number
  const currentPrice = +number;
  const priceWithoutDecimal = +currentPrice.toFixed(0)
  const formatedPrice = priceWithoutDecimal.toLocaleString()
  return `${localizationCurrencyCode} ${formatedPrice}`;
};

const calculateSelectedVariant = () => {
  const selectedColor = getSelectedColor();
  const selectedOptions = state.optionGroups.reduce(
    (acc, curr) => {
      const sizeValue = curr.selectedTitle.textContent.trim();
      if (reverseSizesMap.has(sizeValue)) {
        return [...acc, reverseSizesMap.get(sizeValue)];
      }
      return [...acc, sizeValue];
    },
    selectedColor ? [selectedColor] : []
  );

  const matchedVariant = state.product.variants.find((variant) =>
    selectedOptions.every((option, index) => variant.options[index] === option)
  );

  state.selectedVariant = matchedVariant;

  return matchedVariant;
};


const updateSelectedVariantUrl = () => {
  if (state.selectedVariant) {
    setQueryParams({ variant: state.selectedVariant.id });
  } else {
    removeQueryParams(['variant']);
  }
};

const showNotify = () => {
  const { selectedVariant } = state;

  if (!selectedVariant) return;

  state.elements.pdpQuantityWrapper.classList.toggle(
    'out-of-stock',
    !selectedVariant.available
  );
};

function onOptionChange(e) {
  state.elements.buttonErrorMessage.textContent = '';
  const sizeKey = e.target.value;
  if (sizesMap.has(sizeKey)) {
    this.selectedTitle.textContent = sizesMap.get(sizeKey);
  } else {
    this.selectedTitle.textContent = e.target.value;
  }
  this.errorMessage.classList.remove('error');

  updateProductPrice(calculateSelectedVariant());
  updateSelectedVariantUrl();
  showNotify();
}

const getFirstUnselectedOption = () =>
  state.optionGroups.find((group) => !group.selectedTitle.textContent.trim());

const validateForm = () => {
  const firstUnselectedOption = getFirstUnselectedOption();

  if (!firstUnselectedOption) return false;

  firstUnselectedOption.errorMessage.classList.add('error');

  return firstUnselectedOption;
};

const addToCart = async (productId, quantity) => {
  const formData = {
    items: [{ id: productId, quantity }],
  };

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });

  return response.json();
};

const addToCartFunction = async (e) => {
  e.preventDefault();

  state.elements.buttonErrorMessage.textContent = '';

  if (validateForm()) return;

  const matchedVariant = calculateSelectedVariant();

  if (!matchedVariant) return;

  const productId = matchedVariant.id;
  const quantity = +state.elements.quantity.value;
  const originalAddToCartText = state.elements.addToCart.textContent;
  state.elements.addToCart.textContent = 'Adding to Cart...';

  // const items = [{ id: productId, quantity }];

  const { price, compare_at_price, sku, id } =
    await getProductVariantData(matchedVariant);
  const items = [
    {
      id,
      quantity,
      properties: {
        _OriginalPrice: `$${(+price).toFixed(2)}`,
        _ProductSku: retrieveSku(sku),
        _CompareAtPrice:
          compare_at_price && `$${(+compare_at_price).toFixed(2)}`,
        _productTitle: replaceWords(state.product.title),
      },
    },
  ];

  if (isFinalSale(price, compare_at_price) || isUnreturnable(state.product)) {
    items[0].properties._finalSale = 'Final Sale';
    items[0].properties._LPROP = 'Final Sale';
  }

  try {
    state.elements.quantity.value = 1;
    const response = await onAddToCartService(items, matchedVariant);
    if (response.message) {
      state.elements.buttonErrorMessage.textContent = response.message;
    }
  } catch (error) {
    console.log('Error Message', error);
  } finally {
    setTimeout(() => {
      state.elements.addToCart.textContent = originalAddToCartText;
    }, 100);
  }
};

const updateProductHandle = (newHandle) => {
  state.selectedVariant = null;
  updateSelectedVariantUrl();

  const newPathName = `${window.location.origin}/products/${newHandle}${window.location.search}`;
  window.history.replaceState({}, '', newPathName);
};

const updateProductSelectionUI = (productHandle) => {
  const { product } = state;
  state.elements.productTitle.textContent = replaceWords(product.title);
  state.elements.optionColors.forEach(
    (color) => (color.textContent = product.variants[0].option1)
  );

  state.optionGroups.forEach((group) => {
    group.selectedTitle.textContent = '';
  });

  state.elements.colorOptions.forEach((item) => {
    item.classList.toggle('active', item.dataset.handle === productHandle);
  });
};

const getImageMarkup = (image) => `
        <figure
            itemprop="associatedMedia"
            itemscope
            itemtype="http://schema.org/ImageObject"
            class="slider-item swiper-slide placeholder-loader__content"
        >
        <a
            href="${image}&width=2500"
            data-caption="Sea side, south shore<br><em class='text-muted'>© Dominik Schröder</em>"
            data-pswp-width="2500" 
            data-pswp-height="2500"
            itemprop="contentUrl"
            class="pdp-slider__image"
        >
            <img class="slider-img-item" loading="lazy" itemprop="thumbnail" src="${image}&width=2000" width="100%" height="100%" alt="${state.product.title}">
        </a>
        </figure>
    `;

const getVideoMarkup = (video) => `
        <div class="slider-item item-video swiper-slide placeholder-loader__content">
            <video class="slider-video-item" autoplay muted loop playsinline style="width: 100%; height: 100%;" type="video/mp4" src="${video}">
            </video>
        </div>
    `;

const updateProductGallery = (product) => {
  const markup = product.images.reduce((acc, curr, index) => {
    const imageMarkup = getImageMarkup(curr);
    acc += imageMarkup;

    if (index == 0 && product.video) {
      const videoMarkup = getVideoMarkup(product.video);
      acc += videoMarkup;
    }

    return acc;
  }, '');

  state.elements.sliderGrid.innerHTML = markup;
};

const getOptionValues = (optionIndex) => {
  const values = state.product.variants.map(
    (variant) => variant.options[optionIndex]
  );
  return [...new Set(values)];
};

const getOptionsValuesMarkup = (option, optionIndex) => {
  const options = getOptionValues(optionIndex);
  return options
    .map((value) => {
      let isOutOfStock = true;
      state.product.variants.forEach((variant) => {
        if (variant.options[optionIndex] == value && variant.available) {
          isOutOfStock = false;
        }
      });
      if (option == 'Color') return null;
      return `
            <div class="pdp__option--variants">
                <input
                    class="pdp__option--input"
                    type="radio"
                    required
                    name="${option}"
                    value="${value}"
                    id="${option.toLowerCase().replace(/\s+/g, '-')}-${value.toLowerCase().replace(/\s+/g, '-')}"/>
                <label class="pdp__option--variants-label ${isOutOfStock ? 'pdp__option--disabled' : null}" for="${option.toLowerCase().replace(/\s+/g, '-')}-${value.toLowerCase().replace(/\s+/g, '-')}">${value}</label> 
                ${isOutOfStock ? '<span class="pdp__option--sold-out">Sold Out</span>' : ''}
            </div>
        `;
    })
    .filter(Boolean)
    .join('');
};

const updateProductPrice = (variant) => {
  if (variant) {
    state.elements.productPrice.textContent = formatPrice(variant.price / 100);
    state.elements.compareAtprice.textContent = variant.compare_at_price ? formatPrice(variant.compare_at_price / 100) : '';
  }
}

const updateOptions = () => {
  const markup = state.product.options
    .map(getOptionsValuesMarkup)
    .filter(Boolean);

  state.optionGroups.forEach((group, index) => {
    group.fieldSet.innerHTML = markup[index];
  });
};

const updateAccordionInfo = () => {
  const { product } = state;
  state.elements.accordionProductVariant.textContent = `${product.variants[0].options[0]}`;
};

const replaceProductDescriptionWord = () => {
  const descriptionText = state.elements.accordionProductDescription.innerHTML;
  state.elements.accordionProductDescription.innerHTML = replaceWords(descriptionText);
};

const updateProductAvailability = (force) => {
  state.elements?.productSoldOutLabel?.classList.toggle('out-of-stock', !force);
  state.elements.pdpQuantityWrapper.classList.toggle('out-of-stock', !force);
};

const updateOnlineExclusive = (e) => {
  const exclusiveLabel =
    e.target.closest('[data-exclusive]')?.dataset?.exclusive;
  if(!exclusiveLabel) return; 
  state.elements.onlineExclusiveLabel.classList.toggle(
    'active',
    exclusiveLabel
  );
  state.elements.onlineExclusive.textContent = exclusiveLabel;
};

const onColorChange = (e) => {
  state.elements.buttonErrorMessage.textContent = '';
  state.elements.quantity.value = 1;
  const productHandle = e.target.closest('[data-handle]')?.dataset?.handle;
  const product = window.relatedProducts.find(
    (product) => product.handle === productHandle
  );
  if (!product) return;

  state.product = product;
  const isAvailable = product.variants.some((variant) => variant.available);
  updateOnlineExclusive(e);
  updateProductSelectionUI(productHandle);
  updateProductGallery(product);
  updateProductAvailability(isAvailable);
  updateAccordionInfo();
  updateOptions();
  state.isPDP && updateProductHandle(productHandle);
};

const onDesktopMediaChange = () => {
  if (DESKTOP_MEDIA.matches) {
    state.swiper?.destroy();
    return;
  }
  initSwipers();
  state.swiper.update();
};

const showColor = (optionsCount) => {
  if(optionsCount < 2) return;
  state.elements.body.classList.add('active');
};

const removeColor = () => {
  state.elements.body.classList.remove('active');
};

const showNotifyModal = () => {
  state.elements.body.classList.toggle('notify-active');
};

const onKlarnaLoad = (mutationList, observer) => {
  const desktopKlarna = document.querySelector('.klarna-pay--wrapper-desktop klarna-placement')?.shadowRoot;
  const desktopStyle = document.createElement('style');
  desktopStyle.innerHTML = `
  .badge svg {
    max-width: 55px
  }
  .container { 
    border:none!important;
  };
    `;

  requestAnimationFrame(() => {
    desktopKlarna?.appendChild(desktopStyle);
  });

  mutationList.forEach((list) => {
    const shadowRoot =
      list.target.querySelector('klarna-placement')?.shadowRoot;
    const container = shadowRoot?.querySelector('.container');
    if (!shadowRoot) return;
    const style = document.createElement('style');
    style.innerHTML = `
          .container { 
            border:none!important;
            padding:0!important; 
          };
      
          .container > p {
            font-family: "GalanoGrotesqueRegular", sans-serif!important;
            text-align: start!important;
          };
      
          .container .logo {
            font-family: inherit!important;
            font-weight: 400!important;
            letter-spacing: inherit!important;
            font-size: inherit!important;
          };
      
          .text-wrapper {
            font-size: 1.2rem!important;
            line-height: 1.6!important;
          };
      
          .text-wrapper button {
            font-size: 1.2rem!important;
            line-height: 1.6!important;
          }
          .badge {
            max-width: 55px;
          };
        `;

    shadowRoot.appendChild(style);

    if (!container) return;
    observer.disconnect();
  });
};

const showFitModal = () => {
  state.elements?.fitModal?.classList.toggle('active');
};

const onFetchNotify = (e) => {
  e.preventDefault();
  e.stopPropagation();
  const matchedVariant = calculateSelectedVariant();
  const isValidEmail = state.elements.notifyEmailInput.checkValidity();
  if (!isValidEmail) {
    onInvalidEmail();
    return;
  }
  const email = state.elements.notifyEmailInput.value;
  state.elements.notifyBtnCta.innerHTML = 'Processing';

  fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: `a=${state.klaviyoAccountID}&email=${email}&variant=${matchedVariant.id}&platform=shopify`,
  })
    .then((data) => data.json())
    .then(
      (response) => {
        if (response.success) {
          state.elements.notifyBtnCta.innerHTML = 'Added to list';
          state.elements.notifyEmailInput.value = '';
          setTimeout(() => {
            state.elements.notifyBtnCta.innerHTML = 'Notify me';
            showNotifyModal();
          }, 3000);
        } else {
          state.elements.notifyBtnCta.innerHTML = 'Error. Try again';
        }
      },
      () => {
        state.elements.notifyBtnCta.innerHTML = 'Error. Try again';
      }
    );
};

const onInvalidEmail = (e) => {
  e?.preventDefault();
  state.elements.notifyInvalidEmail.classList.add('invalid');
};

const onEmailChange = (e) =>
  state.elements.notifyInvalidEmail.classList.remove('invalid');

const attachEventListeners = () => {
  state.elements.notifyBtnCta.addEventListener('click', onFetchNotify);
  state.elements.notifyInvalidEmail.addEventListener('invalid', onInvalidEmail);
  state.elements.notifyEmailInput.addEventListener('input', onEmailChange);
  state.elements.quantitySelector.addEventListener(
    'click',
    handleQuantityClick
  );
  state.elements.quantity.addEventListener('input', handleQuantityInput);
  state.elements?.fitCloseButton?.addEventListener('click', showFitModal);
  state.elements?.fitGuide?.addEventListener('click', showFitModal);
  state.elements.notifyButton.addEventListener('click', showNotifyModal);
  state.elements.notifyBackdrop.addEventListener('click', showNotifyModal);
  state.elements?.optionBottomBackdrop?.addEventListener('click', removeColor);
  state.elements?.optionColorWrapper?.addEventListener('click', () => showColor(state.elements.optionColorWrapper.dataset.optionsCount));
  state.elements?.optionColorClose?.addEventListener('click', showColor);
  state.optionGroups.forEach((group) => {
    group.wrapper.addEventListener('change', onOptionChange.bind(group));
  });
  state.elements?.colorsContainer?.addEventListener('click', (e) => {
    onColorChange(e);
    removeColor();
  });
  state.elements.addToCart.addEventListener('click', addToCartFunction);
  state.elements.klarnaWrappers.forEach((wrapper) => {
    const KlarnaLoadObserver = new MutationObserver(onKlarnaLoad);
    KlarnaLoadObserver.observe(wrapper, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  });
  DESKTOP_MEDIA.onchange = onDesktopMediaChange;

  if (state.elements.formContainer) {
    new OverflowScroller(state.elements.formContainer);
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const target = node.querySelector('a.closeShipInsureModal');
            if (target) {
              target.setAttribute('href', '#');
              observer.disconnect();
            }
          }
        });
      } else if (mutation.type === 'attributes') {
        const { target } = mutation;
        if (target.classList.contains('closeShipInsureModal')) {
          target.setAttribute('href', '#');
          observer.disconnect();
        }
      }
    }
  });

  const config = { attributes: true, childList: true, subtree: true };

  const targetNode = document.body;
  observer.observe(targetNode, config);
};

const init = () => {
  const hasProduct = window.product;
  const isAlreadyRun = isScriptFullyLoaded('pdp');

  if (!hasProduct) return;
  if (isAlreadyRun && state.isPDP) {
    markScriptFullyLoaded('pdp');
    return;
  }

  cacheState();
  attachEventListeners();
  onDesktopMediaChange();
  replaceProductDescriptionWord();
};

onDocumentReady(init);
